
import { Component, Mixins } from "vue-property-decorator";
import { IPageExtendBehavior } from "../../../../../../documaker/domain/format/objects";
import { IPageExtendBehaviorPropertyEditable, instanceOfIPageExtendBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class PageExtendBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IPageExtendBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IPageExtendBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isPageExtendBehaviorPropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIPageExtendBehaviorPropertyEditable(s) && s.pageExtendBehavior().isEditable(), false);
  }

  get pageExtendBehavior(): IPageExtendBehavior {
    return this.readPropertyOrDefault(s => s.pageExtendBehavior().getValue(), { isEnable: false, fontSizeThreshold: 8, shouldMoveAllText: true, shouldOverwrite: false });
  }

  set pageExtendBehavior(value: IPageExtendBehavior) {
    this.writePropertyWhenValid(s => s.pageExtendBehavior().setValue(value));
  }
}
